import * as color from './PeriscopeHeader.module.scss';

import { getSonarObjectTypeSourceLabel } from '@sonar-software/sonar-ts-lib';
import { ORGANIZATION_TYPE_LABELS } from '@sonar-software/sonar-ts-constants';
import { PeriscopeClose } from './PeriscopeClose';
import { PeriscopeSourceLabel } from './PeriscopeSourceLabel';
import { PeriscopeTypeLabel } from './PeriscopeTypeLabel';
import { SonarObjectType } from '@sonar-software/sonar-ts-types';

import React, { useMemo } from 'react';

export interface PeriscopeHeaderProps {
	headerLabel?: string;
	index: number;
	sonarObjectType: SonarObjectType;
	subType?: string;
	url?: string;
}

const headerBackgroundColorMap: Record<string, string> = {
	[ ORGANIZATION_TYPE_LABELS.PARDOT ]: color.pardotBlue,
	[ ORGANIZATION_TYPE_LABELS.SALESFORCE ]: color.salesforceBlue,
	[ ORGANIZATION_TYPE_LABELS.SONAR ]: color.arovyBlue
};

export const PeriscopeHeader: React.FC<PeriscopeHeaderProps> = ({
	headerLabel,
	index,
	sonarObjectType,
	subType,
	url
}) => {
	const headerColor = useMemo(
		() => headerBackgroundColorMap[ getSonarObjectTypeSourceLabel(sonarObjectType) ],
		[ sonarObjectType ]
	);

	return (
		<div
			className='periscope-header-wrapper'
			style={ { background: headerColor } }>
			<PeriscopeTypeLabel
				headerLabel={ headerLabel }
				sonarObjectType={ sonarObjectType }
				subType={ subType } />
			<PeriscopeSourceLabel
				sonarObjectType={ sonarObjectType }
				url={ url } />
			<PeriscopeClose index={ index } />
		</div>
	);
};
